module.exports = __webpack_public_path__ + "static/assets/d81e68c7e735a7652ce18b63c9e3a0b9.svg";